import { sammelnClient } from '@xver/libs/axios';

import {
    CreateProjectRequest,
    DeleteProjectRequest,
    DeleteProjectResponse,
    ListProjectsResponse,
    ProjectResponse,
} from './model';

const ENDPOINTS = {
    LIST: '/v1/projects',
    CREATE: '/v1/projects',
    GET: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}`,
    DELETE: (projectIdOrName: string) => `/v1/projects/${projectIdOrName}`,
};

export function listProjects(): Promise<ListProjectsResponse> {
    return sammelnClient.get(ENDPOINTS.LIST);
}

export function getProject(projectIdOrName: string): Promise<ProjectResponse> {
    return sammelnClient.get(ENDPOINTS.GET(projectIdOrName));
}

export function createProject(data: CreateProjectRequest): Promise<ProjectResponse> {
    return sammelnClient.post(ENDPOINTS.CREATE, data);
}

export function deleteProject(
    projectIdOrName: string,
    data: DeleteProjectRequest
): Promise<DeleteProjectResponse> {
    return sammelnClient.delete(ENDPOINTS.DELETE(projectIdOrName), { data });
}
